import "./inventory.css";
import React, { useState } from "react";
import momentTZ from 'moment-timezone';


export default function RedemptionSortableTable({ data }) {
    const [sortConfig, setSortConfig] = useState({ key: '', direction: "asc" });

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...data].sort((a, b) => {
        if (!sortConfig.key) return 0;
        const valA = a[sortConfig.key];
        const valB = b[sortConfig.key];
        if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return (<svg width="10" height="10" viewBox="0 0 10 10">
            </svg>);
        }
        return sortConfig.direction === "asc" ? (
            <svg width="10" height="10" viewBox="0 0 10 10">
                <path d="M0 6 L5 1 L10 6 Z" fill="#999" />
            </svg>
        ) : (
            <svg width="10" height="10" viewBox="0 0 10 10">
                <path d="M0 4 L5 9 L10 4 Z" fill="#999" />
            </svg>
        );
    };

    return (
        <table className="styled-table">
            <thead>
                <tr>
                    <th onClick={() => handleSort("coupon_code")}>
                        Coupon Code {getSortIcon("coupon_code")}
                    </th>
                    <th onClick={() => handleSort("reward_type")}>
                        Reward Type {getSortIcon("reward_type")}
                    </th>
                    <th onClick={() => handleSort("category")}>
                        Campaign Category {getSortIcon("category")}
                    </th>
                    <th onClick={() => handleSort("name")}>
                        Name {getSortIcon("name")}
                    </th>
                    <th onClick={() => handleSort("sap_no")}>
                        SAP No {getSortIcon("sap_no")}
                    </th>
                    <th onClick={() => handleSort("bc_no")}>
                        BC No {getSortIcon("bc_no")}
                    </th>
                    <th onClick={() => handleSort("operator_name")}>
                        Operator Name {getSortIcon("operator_name")}
                    </th>
                    <th onClick={() => handleSort("status")}>
                        Status {getSortIcon("status")}
                    </th>
                    <th onClick={() => handleSort("redeemed_on")}>
                        Redeemed/Acknowledged On {getSortIcon("redeemed_on")}
                    </th>
                    <th onClick={() => handleSort("remark")}>
                        Remarks {getSortIcon("remark")}
                    </th>
                </tr>
            </thead>
            <tbody>
                {sortedData.map((row, index) => (
                    <tr key={index}>
                        <td>{row.coupon_code}</td>
                        <td>{row.reward_type || '-'}</td>
                        <td>{row.category || '-'}</td>
                        <td>{row.name}</td>
                        <td>{row.sap_no || '-'}</td>
                        <td>{row.bc_no}</td>
                        <td>{row.operator_name || '-'}</td>
                        <td>{row.status || '-'}</td>
                        <td>{row.redeemed_on && row.redeemed_on != '-' ? momentTZ.tz(`${row.redeemed_on}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD MMM YYYY, hh:mm A') : "-"}</td>
                        <td>{row.remark || '-'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}